import { ContentDataFragment } from '@typings/graphql'

import { AnnotatedVideoContentEditor } from './AnnotatedVideoContentEditor'
import { ArContentEditor } from './ArContentEditor'
import { AudioCarouselContentEditor } from './AudioCarouselContentEditor'
import { AudioMemoContentEditor } from './AudioMemoContentEditor'
import { AudioPlayerContentEditor } from './AudioPlayerContentEditor'
import { CameraViewContentEditor } from './CameraViewContentEditor'
import { CarouselContentEditor } from './CarouselContentEditor'
import { ComparisonSliderEditor } from './ComparisonSliderEditor'
import { CompassContentEditor } from './CompassContentEditor'
import { CustomContentEditor } from './CustomContentEditor'
import { EstimationSliderContentEditor } from './EstimationSliderContentEditor'
import { FeaturedPoisContentEditor } from './FeaturedPoisContentEditor'
import { ImageContentEditor } from './ImageContentEditor'
import { InfoCarouselContentEditor } from './InfoCarouselContentEditor'
import { LinkBoxContentEditor } from './LinkBoxContentEditor'
import { LiveInteractionCardEditor } from './LiveInteractionCardEditor'
import { MarkdownContentEditor } from './MarkdownContentEditor'
import { MultipleChoicePollContentEditor } from './MultipleChoicePollContentEditor'
import { PollContentEditor } from './PollContentEditor'
import { QuickTipContentEditor } from './QuickTipContentEditor'
import { QuizContentEditor } from './QuizContentEditor'
import { ScratchCardContentEditor } from './ScratchCardContentEditor'
import { SwipeCardsSurveyContentEditor } from './SwipeCardsSurveyContentEditor'
import { SwipeCardsTestContentEditor } from './SwipeCardsTestContentEditor'
import { TextContentEditor } from './TextContentEditor'
import { VideoContentEditor } from './VideoContentEditor'
import { VideoQuizContentEditor } from './VideoQuizContentEditor'
import { VoiceoverContentEditor } from './VoiceoverContentEditor'
import { LinkContentEditor } from './LinkContentEditor'

export type ContentEditorComponentProps = {
  nuggetId: string,
  content: ContentDataFragment,
  blocksContent: boolean,
  refetch?: Function,
  onEdited?: Function,
}

export const contentTypeEditors = {
  annotatedVideo: AnnotatedVideoContentEditor,
  ar: ArContentEditor,
  audioCarousel: AudioCarouselContentEditor,
  audioMemo: AudioMemoContentEditor,
  audioPlayer: AudioPlayerContentEditor,
  cameraView: CameraViewContentEditor,
  carousel: CarouselContentEditor,
  comparisonSlider: ComparisonSliderEditor,
  compass: CompassContentEditor,
  custom: CustomContentEditor,
  estimationSlider: EstimationSliderContentEditor,
  featuredPois: FeaturedPoisContentEditor,
  image: ImageContentEditor,
  infoCarousel: InfoCarouselContentEditor,
  link: LinkContentEditor,
  linkBox: LinkBoxContentEditor,
  liveInteractionCard: LiveInteractionCardEditor,
  markdown: MarkdownContentEditor,
  multipleChoicePoll: MultipleChoicePollContentEditor,
  poll: PollContentEditor,
  quickTip: QuickTipContentEditor,
  quiz: QuizContentEditor,
  scratchCard: ScratchCardContentEditor,
  swipeCardsSurvey: SwipeCardsSurveyContentEditor,
  swipeCardsTest: SwipeCardsTestContentEditor,
  text: TextContentEditor,
  video: VideoContentEditor,
  videoQuiz: VideoQuizContentEditor,
  voiceover: VoiceoverContentEditor
}

export default contentTypeEditors

// interactiveZoom: InteractiveZoomContentEditor
// animatedNumber: AnimatedNumberContentEditor
